import { t } from "@/i18n-js/instance";
import { Icon } from "@circle-react-shared/Icon";

const i18nRoot = "settings.workflows.form";

interface StatusIconContentProps {
  hasError: boolean;
}

export const StatusIconContent = ({ hasError }: StatusIconContentProps) => (
  <span className="flex items-center">
    {hasError ? (
      <Icon
        type="20-alert"
        size={20}
        className="!text-v2-danger"
        aria-label={t([i18nRoot, "step_incomplete"])}
      />
    ) : (
      <Icon
        type="20-checkmark-circle-fill-thin"
        size={20}
        aria-label={t([i18nRoot, "step_complete"])}
      />
    )}
  </span>
);
